import { EMERGENCY_NUMBERS } from './schemas.js';
/** Whether what someone typed is an emergency number (112, 999, …). */
export function isEmergencyNumber(typed) {
    return EMERGENCY_NUMBERS.has(typed.replace(/[\s()-]/g, ''));
}
const refusals = {
    emergency: 'Emergency numbers can’t be called from here. Use your mobile phone.',
    'invalid-number': 'That isn’t a complete phone number.',
    'country-not-allowed': 'Calls to that country aren’t allowed for your region.',
    'premium-rate': 'Premium-rate numbers can’t be called.',
    'no-number': 'You have no number to call out from yet. Ask your administrator.',
    'unknown-destination': 'No one has that extension.',
    'daily-cap': 'Your calling minutes for today are used up.',
    'tenant-daily-cap': 'The company’s calling minutes for today are used up.',
    'too-many-calls': 'You already have as many calls going as you’re allowed.',
    'tenant-busy': 'All lines are busy. Try again in a minute.',
    unavailable: 'That person can’t take calls right now.',
    // A call out that the phone company didn't put through (its hang-up cause).
    busy: 'The number is busy. Try again later.',
    'number-not-in-use': 'That number isn’t in use. Check it and try again.',
    unreachable: 'That number can’t be reached right now.',
    'line-unavailable': 'The phone company’s line is busy or down. Try again in a minute.',
    'carrier-refused': 'The phone company refused the call. If it keeps happening, tell your administrator.',
    'carrier-failed': 'The phone company couldn’t put the call through. Try again in a minute.',
};
/** Why the phone system refused a call, in words for the caller. */
export function refusalText(reason) {
    return (reason && refusals[reason]) || 'The call couldn’t be made.';
}
/**
 * Why a call didn't go through, for the person who made it: refused by the
 * phone system, or not put through by the phone company. Null for a call
 * that went through, or was just not answered or hung up.
 */
export function callFailureText(call) {
    if (call.outcome === 'REJECTED')
        return refusalText(call.rejectReason);
    if (call.outcome !== 'FAILED' && call.outcome !== 'BUSY')
        return null;
    // Calls out ended before this reason was kept, and calls to colleagues, get the usual words.
    const usual = call.outcome === 'BUSY' ? 'busy' : call.direction === 'OUTBOUND' ? 'carrier-failed' : null;
    return refusalText(call.rejectReason ?? usual);
}
/**
 * What to dial to call back from a call: the outside party's number, or on
 * an internal call, for the two people on it, the colleague's extension.
 * Null when there is nothing to call (a withheld number, someone else's call).
 */
export function callBackNumber(call, viewerId) {
    const number = call.direction === 'INBOUND'
        ? call.fromNumber
        : call.direction === 'OUTBOUND'
            ? call.toNumber
            : call.userId === viewerId
                ? call.toNumber
                : call.toUserId === viewerId
                    ? call.fromNumber
                    : null;
    return number && /^\+?\d{2,15}$/.test(number) ? number : null;
}
